import React, { createContext, useContext, useMemo, useState } from 'react';

type BCPHeaderActionsContextValue = {
  actions: React.ReactNode;
  setActions: (actions: React.ReactNode) => void;
};

const BCPHeaderActionsContext = createContext<BCPHeaderActionsContextValue | null>(null);

export const BCPHeaderActionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [actions, setActions] = useState<React.ReactNode>(null);
  const value = useMemo(() => ({ actions, setActions }), [actions]);

  return (
    <BCPHeaderActionsContext.Provider value={value}>
      {children}
    </BCPHeaderActionsContext.Provider>
  );
};

export function useBCPHeaderActions(): BCPHeaderActionsContextValue {
  const context = useContext(BCPHeaderActionsContext);
  if (!context) {
    throw new Error('useBCPHeaderActions must be used within BCPHeaderActionsProvider');
  }
  return context;
}

export const BCPHeaderActionsSlot: React.FC = () => {
  const { actions } = useBCPHeaderActions();
  if (!actions) return null;

  return (
    <div className="ml-4 shrink-0 flex items-center gap-2 flex-wrap justify-end">
      {actions}
    </div>
  );
};
